import { etiquetaAlicuota, TotalAlicuotaVenta } from '../lib/ivaVenta';

const pesos = (n: number | string) => `$ ${Number(n).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** Tabla de IVA por alícuota: neto, IVA y total (IVA incluido) de cada alícuota. Facturas y notas de venta. */
export function TablaIvaPorAlicuota({ filas }: { filas: TotalAlicuotaVenta[] }) {
  const neto = filas.reduce((s, f) => s + f.netoGravado, 0);
  const iva = filas.reduce((s, f) => s + f.iva, 0);
  return (
    <table className="w-full text-sm">
      <thead><tr className="text-left text-slate-500"><th className="py-1">Alícuota</th><th className="text-right">Neto gravado</th><th className="text-right">IVA</th><th className="text-right">Total</th></tr></thead>
      <tbody>
        {filas.map(f => (
          <tr key={f.alicuota} className="border-t">
            <td className="py-1">{etiquetaAlicuota(f.alicuota)}</td>
            <td className="text-right">{pesos(f.netoGravado)}</td>
            <td className="text-right">{pesos(f.iva)}</td>
            <td className="text-right">{pesos(f.netoGravado + f.iva)}</td>
          </tr>
        ))}
        <tr className="border-t font-medium">
          <td className="py-1">Total</td>
          <td className="text-right">{pesos(neto)}</td>
          <td className="text-right">{pesos(iva)}</td>
          <td className="text-right">{pesos(neto + iva)}</td>
        </tr>
      </tbody>
    </table>
  );
}
